import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { useAuth } from './auth/useAuth';
import { TabBar } from './components/TabBar';
import { AuthCallback } from './screens/AuthCallback';
import { Bride } from './screens/Bride';
import { Couple } from './screens/Couple';
import { Groom } from './screens/Groom';
import { Login } from './screens/Login';
import { Overview } from './screens/Overview';
import { Register } from './screens/Register';
import { SignUp } from './screens/SignUp';

function Splash() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        color: 'var(--text-dim)',
      }}
    >
      <span className="serif" style={{ fontSize: '1.6rem' }}>
        Lynne &amp; Andi
      </span>
    </div>
  );
}

/** App layout for signed-in users; redirects to /login otherwise. */
function Protected() {
  const { status, signOut } = useAuth();
  if (status === 'loading') return <Splash />;
  if (status === 'unauthenticated') return <Navigate to="/login" replace />;
  return (
    <div className="app-shell">
      <button
        type="button"
        onClick={signOut}
        style={{
          position: 'absolute',
          top: 14,
          right: 16,
          zIndex: 2,
          background: 'none',
          border: 'none',
          color: 'var(--text-dim)',
          fontSize: 12,
        }}
      >
        Sign out
      </button>
      <main style={{ paddingBottom: 'calc(var(--tabbar-h) + env(safe-area-inset-bottom))' }}>
        <Outlet />
      </main>
      <TabBar />
    </div>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route element={<Protected />}>
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/couple" element={<Couple />} />
          <Route path="/bride" element={<Bride />} />
          <Route path="/groom" element={<Groom />} />
          <Route path="/register" element={<Register />} />
        </Route>
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Routes>
    </AuthProvider>
  );
}
